<div class="container-fluid padM0">
    <!-- Header -->
    <div class="col-md-12 col-lg-12 col-12 padLeft25" style="padding: 15px; padding-bottom: 0px;">
        <div class="col-md-7 col-lg-7 col-12" style="display: inline-block; padding: 0px;">
            <div class="col-md-12 col-lg-12 col-12" style="padding: 0px; display: inline-block;">
                <span class="mobView" style="font-size: 22px; margin-right: 10px; display: inline-block;"
                    (click)="backBtn()"><i class="fa fa-chevron-left"></i>
                </span>
                <span class="mobView newHeader" style="font-size: 22px; display: inline-block; margin-right: 10px; display: inline-block;">
                    {{ title }}
                </span>
                
                <h4 class="newHeader webView">{{ title }}</h4>
            </div>
            <div class="col-md-2 col-lg-2 col-2" *ngIf="rights.materialIssue"
                style="padding: 0px; display: inline-block; text-align: right; display: none;">
                <div class="yellowBadge" style="margin-top: 5px; padding: 6px 13px;"
                    (click)="openItemSelect(selectItem)"><i class="fa fa-plus"></i></div>
            </div>
        </div>
        <div class="col-md-5 col-lg-5 col-3 webView" style="display: inline-block; text-align: right; padding: 0px;">
            <div class="btn-orange font13 brdrRadius3" style="padding: 2px 12px;  margin-right: 10px;"
                (click)="openItemSelect(selectItem)" *ngIf="id != 6">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="margin-right: 5px;"></i>Select More Items
            </div>

            <span class="btn-darkBlue font13 brdrRadius3" style="display: inline-block; padding: 2px 10px;" (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
            </span>
        </div>

        <!-- Store Transfer -->
    </div>

    <div class="col-md-12 col-lg-12 col-12" style="display: flex; padding: 0px;margin-top: 10px;">
        <div class="col-md-10 col-lg-10 col-12 padLeft5" style="padding: 0px; display: inline-block;">
            <div class="com-md-12 col-lg-12 col-12" style="padding: 0px;">
                <div class="col-md-12 col-lg-12 col-12" style="padding-bottom: 0px; display: inline-block;">
                    <!-- <div class="greenBadge" style="margin-right: 10px; cursor: pointer;" (click)="isStoreSelected ? isStoreSelected = false : selectStore(storeSelect)">Issue {{ isStoreSelected ? 'from ' + storeName : 'Material' }} <i class="fa fa-times" *ngIf="isStoreSelected" aria-hidden="true" style="margin-left: 5px;"></i></div> -->
                    <div class="orangeBadge font13 brdrRadius3 orangeBrdr brdr" style="margin-right: 10px; cursor: pointer; padding: 4px 12px;"
                        (click)="selectStore()"><i class="zmdi zmdi-city-alt" style="margin-right: 5px;"></i>{{
                        frmStore.id == 0 ? 'Select Store' : frmStore.name}}<i class="fa fa-pencil"
                            style="margin-left: 5px;"></i></div>
                    <div class="yellowBadge font13 brdrRadius3 brdr" style="margin-top: 10px; margin-right: 10px; cursor: pointer;padding: 4px 12px;"
                        (click)="openSelectExecutive()"><i class="zmdi zmdi-account" style="margin-right: 5px;"></i> {{
                        executive.id == 0 ? 'Select Executive' : executive.name}}</div>
                    <div class="greenBadge font13 brdrRadius3 brdr" style="margin-top: 10px; margin-right: 10px; cursor: pointer;padding: 4px 12px;"
                        (click)="openSelectJob()"><i class="zmdi zmdi-widgets" style="margin-right: 5px;"></i> {{ wip.no
                        == 0 ? 'Select WIP No.' : wip.no}}<i class="fa fa-pencil" style="margin-left: 5px;"></i></div>
                    <!-- <div class="wid25" style="margin-top: 10px; margin-right: 10px; position: relative; display: inline-block;">
                        <div class="tealBadge">
                            <span style="display: inline-block;"><i class="zmdi zmdi-file-text" style="margin-right: 5px; font-size: 17px;"></i>Ref No.</span> 
                            <span style="display: inline-block; width: 45%;"><input type="text" class="form-control" [(ngModel)]="xnCode" style="background-color: inherit; margin-left: 10px; height: 20px;"></span>
                        </div>
                        <span *ngIf="isShowPrevNo" style="position: absolute; top: 98%; left: 5%; color: #777; font-size: 13px; width: 100%;">Prev Ref No. : {{prevXnCode}}</span>
                    </div> -->

                    <!-- <div class="tealBadge disblk mrgRgt10 wid28" style="display: inline-block; margin-top: 10px; margin-right: 10px; position: relative;"> 
                        <i class="zmdi zmdi-file-text" style="margin-right: 5px; font-size: 17px;"></i> 
                        <span style="display: inline-block;">Ref No.</span>
                        <span>
                            <input type="text" class="form-control wid42" [(ngModel)]="xnCode" style="background-color: inherit !important; height: 20px; padding: 2px; display: inline-block; margin-left: 10px;">
                        </span>
                        
                        <span *ngIf="isShowPrevNo" style="color: #777; font-size: 13px; margin-left: 5px; display: none;">(Prev: {{prevXnCode}})</span>
                    </div> -->
                    <div class="tealBadge disblk mrgRgt10 font13 brdrRadius3 brdr"
                        style="display: inline-block; margin-top: 10px; margin-right: 10px; padding-right: 0px;padding: 4px 12px;">
                        <div class="col-md-12" style="padding: 0px;">
                            <div class="{{ isShowPrevNo ? 'col-md-7' : 'col-md-12' }}"
                                style="display: inline-block; padding: 0px;">
                                <i class="zmdi zmdi-file-text" style="margin-right: 5px;"></i>
                                <span style="display: inline-block;">Ref No.</span>
                                <span>
                                    <input type="text" class="form-control" [(ngModel)]="xnCode"
                                        style="background-color: inherit !important; height: 20px; padding: 2px; display: inline-block; margin-left: 10px; width: 50%;">
                                </span>
                            </div>
                            <div *ngIf="isShowPrevNo" class="col-md-5"
                                style="display: inline-block; padding: 0px; width: fit-content;">
                                <span style="color: #777; font-size: 12px; margin-left: 5px;">(Prev:
                                    {{prevXnCode}})</span>
                            </div>
                        </div>
                    </div>

                    <div class="darkBlueBadge font13 brdrRadius3 brdr" style="margin-top: 10px; margin-right: 10px; cursor: pointer;padding: 4px 12px;"
                        (click)="proposeQty()"><i class="fa fa-magic" style="margin-right: 5px; font-size: 13px;"
                            aria-hidden="true"></i>Propose</div>
                    <!-- <div class="brownBadge font13" style="margin-top: 10px; margin-right: 10px; cursor: pointer;">
                    <i class="" style="margin-right: 5px; font-size: 13px;"
                        aria-hidden="true"></i>Remove Zero qty</div> -->
                </div>

                <div class="col-md-2 col-lg-2 col-2 webView"
                    style="padding-bottom: 0px; padding-top: 5px; display: inline-block; text-align: right; padding-left: 0px; display: none;">
                    <div class="btn-yellow font13" style="padding: 4px 12px 4px;" (click)="openItemSelect(selectItem)">
                        <i class="zmdi zmdi-plus" aria-hidden="true" style="margin-right: 5px;"></i>Add Items
                    </div>
                </div>
            </div>

            <div class="col-md-5 col-lg-5 col-5 mobView"
                style="padding-bottom: 0px; padding-top: 5px; display: inline-block;">
                <div class="orangeButton font13" style="padding: 4px 12px 4px; margin-top: 10px;"
                    (click)="openItemSelect(selectItem)">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="margin-right: 5px;"></i>Add Items
                </div>
            </div>

            <div class="col-md-12 col-lg-12 col-12"
                style="display: inline-block; width: 100%; margin-top: 10px; padding-left: 15px; padding-right: 15px; display: none;">
                <div class="input-icons search">
                    <span class="fa fa-search"></span>
                    <input class="form-control searchBar" ng-model="search.term" placeholder="Search"
                        style="padding-left: 35px !important; padding: 20px; border-radius: 25px !important; box-shadow: none; float: left;"
                        type="text">
                </div>
            </div>

            <!-- Body -->
            <div class="row mobView" style="margin: 0px; margin-top: 10px; margin-bottom: 75px;">
                <div class="col-md-12 col-lg-12 col-12" *ngFor="let i of items; let l = last;"
                    style="background: #FFF; padding: 10px 15px 10px 15px; border-top: 10px solid #F8F8F8; {{ l ? 'border-bottom: 10px solid #F8F8F8;' : '' }} font-size: 13px;">
                    <div class="col-md-8 col-lg-8 col-8"
                        style="padding: 0px; display: inline-block; color: #444; font-weight: bold;">
                        {{i.ItemName}}
                    </div>
                    <div class="col-md-4 col-lg-4 col-4"
                        style="padding: 0px; display: inline-block; text-align: right;">
                        <!-- *ngIf="isStoreSelected" -->
                        <span style="width: 46%; display: inline-block;"><input class="form-control" type="text"
                                placeholder="Qty" style="text-align: right;font-size: 13px;" [(ngModel)]="i.issueQty"
                                (change)="getTransferQty()" (keyup)="prcisionCheck(i)"></span>
                        <span> {{i.SKU}}</span>
                        <span style="margin-left: 5px; background: #1111110A; padding: 3px 6px; border-radius: 50%;"
                            (click)="i.issueQty = ''">
                            <i class="fa fa-times" style="color: #777;"></i>
                        </span>
                    </div>
                    <div class="col-md-12 col-lg-12 col-12" style="padding: 0px; display: inline-block;">
                        <div class="darkBlueBadge bgwhite darkBlueBrdr font13 brdrRadius3"
                            style="display: inline-block; margin-right: 10px; margin-top: 10px;">Stock {{i.StrQty}}
                        </div>
                        <div class="darkBlueBadge bgwhite darkBlueBrdr font13 brdrRadius3"
                            style="display: inline-block; margin-right: 10px; margin-top: 10px;">Planned {{i.PlanQty}}
                        </div>
                        <div class="darkBlueBadge bgwhite darkBlueBrdr font13 brdrRadius3"
                            style="display: inline-block; margin-right: 10px; margin-top: 10px;">{{this.id == 8 ?
                            'Generated' : 'Used'}} {{i.DoneQty}}</div>
                            <!-- test - {{i.Batches.length}} - {{i.Batches[0].length}} - {{batchList}} - {{i.batchesList}} -->
                        <div *ngIf="i.hasBatches" class="label darkBlueBadge brdrRadius3 font13"
                            style="display: inline-block;  margin-top: 10px; padding: 5px 10px" (click)="openBatchSelectionMdl(i)"><i class="{{i.isShowBatchEdt ? 'fa fa-pencil' : 'zmdi zmdi-plus' }}" style="margin-right:5px;"></i>Batches</div>
                    </div>
                </div>
            </div>

            <div class="row webView" style="margin: 0px;">
                <div class="col-md-12 col-lg-12 col-12" style="margin-top: 15px;" *ngIf="items.length > 0">
                    <table class="table table-borderd ngTable bzMatTbl shadow brdrRadius3"
                        style="width: 100%; margin-bottom: 10px;  background-color: white;" >
                        <thead style="font-size: 13px; cursor: pointer;">
                            <tr>
                                <th style="width: 200px; padding-left: 10px;border-top: none;">Item Name</th>
                                <th style="width: 90px; text-align: right; border-top: none;">Stock</th>
                                <th style="width: 100px; text-align: right; border-top: none;">Planned</th>
                                <th style="width: 90px; text-align: right; border-top: none;">{{ this.id == 8 ? 'Generated' : 'Used'}}
                                </th>
                                <!-- <th style="width: 100px; padding-left: 15px;">Price</th> -->
                                <th style="width: 130px; padding-right: 25px; text-align: right; border-top: none;">{{ this.id == 6 ?
                                    'Issue Qty' : this.id == 7 ? 'Rtn Qty' : 'Generate Qty'}}</th>
                                <th style="width: 65px; border-top: none;">Unit</th>
                                <th style="width: 100px; border-top: none;" *ngIf="batchCnt > 0"></th>
                                <th style="width: 25px;border-top: none;"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let i of items; let l = last; let in = index;" style="vertical-align: middle;cursor: pointer; ">
                                <td style="padding-left: 10px; vertical-align: middle;">{{i.ItemName}}</td>
                                <td style="text-align: right;vertical-align: middle;">{{i.StrQty}}</td>
                                <td style="text-align: right;vertical-align: middle;">{{i.PlanQty}}</td>
                                <td style="text-align: right;vertical-align: middle;">{{i.DoneQty}}</td>
                                <!-- <td style="padding-left: 15px;"><i class="fa fa-inr" style="margin-right: 7px;"></i>{{i.price | lacFormat : '0'}}</td> -->
                                <td style="padding-right: 25px; text-align: right; vertical-align: middle;">
                                    <span style="display: inline-block; width: 70%;">
                                        <input class="form-control" type="text"
                                            style="text-align: right;  background: inherit; padding-top: 8px;" [(ngModel)]="i.issueQty"
                                            (change)="getTransferQty()" (keyup)="prcisionCheck(i)">
                                    </span>
                                    <!-- <span> no.s</span>  -->
                                    <span
                                        style="margin-left: 5px; background: #1111110A; vertical-align: middle;padding: 3px 6px; border-radius: 50%; cursor: pointer; display: none;"
                                        (click)="i.issueQty = ''; getTransferQty();">
                                        <i class="fa fa-times" style="color: #777;"></i>
                                    </span>
                                </td>
                                <td style="vertical-align: middle;"><span>{{i.SKU}}</span></td>
                                <td style="padding-left: 15px;font-size: 12px;" *ngIf="batchCnt > 0">
                                    <div *ngIf="i.hasBatches" class="lableBtnOrange brdrRadius3 inLneBlk" style="border-radius: 30px;margin-top: 4px; cursor: pointer;" (click)="openBatchSelectionMdl(i)">
                                        <i class="{{i.isShowBatchEdt ? 'fa fa-pencil' : 'zmdi zmdi-plus' }}" style="margin-right:5px;"></i>Batches
                                    </div>
                                </td>   
                                <td style="vertical-align: middle;"><span class="lableBtnGray brdrRadius3" (click)="deleteItem(in)"  title="Delete" style="vertical-align: middle; cursor: pointer;"><i
                                    class="fa fa-trash"></i></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="webView" style="width: 100%; text-align: left; padding-left: 15px;">
                <div style="margin-top: 20px;">
                    <div class="btn-darkBlue font13 brdrRadius3" style="padding: 0px 10px; font-size: 14px; line-height: 30px;" (click)="issue()"><i class="fa fa-check"
                            aria-hidden="true"></i> {{ this.id == 6 ? 'Issue' : 'Receive'}} </div>
                </div>
                <div style="margin-top: 10px;">
                    <div class="font13" style="display: inline-block; margin-right: 10px;"><span
                            style="font-weight: bold;">{{issueQty}}</span> Qty.</div>
                    <div class="font13" style="display: inline-block;"> <span
                            style="font-weight: bold;">{{items.length}}</span> {{ items.length == 1 ? 'Item' : 'Items'}}
                    </div>
                </div>
            </div>

            <div class="mobView2">
                <div class="mrgLeft220"
                    style="position: fixed; width: 100%; bottom: 10px; text-align: center; background-color: #FFF;">
                    <div style="margin-top: 10px;">
                        <div class="btn-blue font13 brdrRadius3" style="padding: 0px 10px; font-size: 14px; line-height: 30px;" (click)="issue()"><i
                                class="fa fa-check" aria-hidden="true"></i> {{ this.id == 6 ? 'Issue' : 'Receive'}}
                        </div>
                    </div>
                    <div style="margin-top: 10px;">
                        <div class="font13" style="display: inline-block; margin-right: 10px;"><span
                                style="font-weight: bold;">{{issueQty}}</span> Qty.</div>
                        <div class="font13" style="display: inline-block;"> <span
                                style="font-weight: bold;">{{items.length}}</span> {{ items.length == 1 ? 'Item' :
                            'Items'}}</div>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-md-5 col-lg-5 col-12"
            style="padding-left: 20px; padding-right: 30px; padding-bottom: 15px; display: inline-block; display: none;">
            <div class="col-md-12 col-lg-12 col-12"
                style="box-shadow: 0 5px 8px rgb(0 0 0 / 20%); background-color: #4caf5016 !important; padding: 0px; border-radius: 25px;">
                <div
                    style="background-image: url(../../../assets/images/feedback.jpg); width: 100%; height: 200px; background-position: center; background-size: cover; border-top-left-radius: 25px; border-top-right-radius: 25px;">
                </div>

                <div class="col-md-12 col-lg-12 col-12" style="padding: 20px 15px;">
                    <div class="greenText" style="font-size: 22px;"> <i class="fa fa-check greenText"
                            style="font-size: 20px; margin-right: 7px;"></i> Order Status Updates</div>
                    <div class="greenText" style="font-size: 13px;">Empower customers; save time from follow-ups</div>

                    <div class="greenText" style="font-size: 22px; margin-top: 30px;"> <i class="fa fa-check greenText"
                            style="font-size: 20px; margin-right: 7px;"></i> Timely Delivery</div>
                    <div class="greenText" style="font-size: 13px;">Track sales commitments; deliver orders punctually
                    </div>

                    <div class="greenText" style="font-size: 22px; margin-top: 30px;"> <i class="fa fa-check greenText"
                            style="font-size: 20px; margin-right: 7px;"></i> Support Ticketing</div>
                    <div class="greenText" style="font-size: 13px;">Resolve support requests; win customer loyalty</div>

                    <div class="greenText" style="font-size: 22px; margin-top: 30px;"> <i class="fa fa-check greenText"
                            style="font-size: 20px; margin-right: 7px;"></i> Effective Feedback</div>
                    <div class="greenText" style="font-size: 13px;">Listen & learn from the customer!</div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- Item Modal -->
<ng-template #selectItem let-modal>
    <app-multiple-select-item></app-multiple-select-item>
</ng-template>

<!-- Store Selection Modal -->
<ng-template #storeSelect let-modal>
    <app-select-store></app-select-store>
</ng-template>

<!-- Store Selection Modal -->
<ng-template #selection let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none; padding-bottom: 0px;">
        <div class="col-md-12 col-sm-12 col-12">
            <div class="row">
                <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
                    <h4 class="modal-title" style="font-size: 22px;"><span id="ApntmntHdr">Select WIP Job(s)</span></h4>
                </div>
                <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;" title="Close">
                    <i class="closeMdl zmdi zmdi-close"  style="float: right;"
                        (click)="modal.dismiss('Cross click')"></i>
                </div>
            </div>
        </div>
    </div>
    
    <!--Body-->
    <div class="modal-body" style="padding-left: 0px; padding-right: 0px;">
        <div class="col-md-12 col-sm-12 col-12" style="padding-left: 17px;">
            <div class="col-md-4 col-sm-4 col-5"
                style="padding: 0px; display: inline-block;  color: #333333;font-size: 15px;"><span style="color: #15304a; margin-right:5px;" ><i
                        class="zmdi zmdi-store" style="margin-right: 5px; font-size: 18px;" ></i></span><span>Store : </span> </div>
            <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                <select class="label Bluebadge form-control width60" [(ngModel)]="frmStore.selID"
                    style="display: inline-block;  font-size: 13px; background: inherit; cursor: pointer;">
                    <option value="0" selected>Select</option>
                    <option *ngFor="let s of stores" [ngValue]="s.StrID">{{s.sNm}}</option>
                </select>
            </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12" style="margin-top: 10px">
            <div class="col-md-4 col-sm-4 col-5 wid24"
                style="padding: 0px; display: inline-block; color: #333333;font-size: 15px;"><span style="margin-right:5px;"><i
                    class="zmdi zmdi-account" style="margin-right: 5px; color: #15304a; font-size: 18px;"></i></span><span>Executive : </span></div>
            <div class="col-md-8 col-sm-8 col-6" style="display: inline-block; padding: 0px;">
                <select class="label Bluebadge form-control width60" [(ngModel)]="executive.selID"
                    style="display: inline-block; font-size: 13px; background: inherit; cursor: pointer;">
                    <option value="0" selected>Select</option>
                    <option *ngFor="let e of executives" [ngValue]="e.UserID">{{e.Name}}</option>
                </select>
            </div>
        </div>


        <div class="col-md-12 col-12 col-sm-12 pad0 padHeder" *ngIf="WIPNos.length > 0"
            style="padding: 0px 15px; margin-top: 20px;">
            <div class="input-icons search">
                <span class="fa fa-search" style="color: #999; font-size: 14px; top:12px !important"></span>
                <input class="form-control searchBar brdrRadius3" [(ngModel)]="search.term" placeholder="Search & Select WIP No."
                    style="padding-left: 35px !important;padding: 16px;border-color: #E4E4E4; box-shadow: none; width: 100%; "
                    type="text">
            </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12"
            style="margin-top: 20px; margin-bottom: 50px; padding: 0px; height: 56vh; overflow-y: auto;">
            <div class="col-md-12 col-sm-12 col-12" style="margin-bottom: 30px;padding: 0px;">
                <div class="col-md-12 col-sm-12 col-12"
                    *ngFor="let w of WIPNos | filter:'JobNo,LaunchDT,CstrRelName':search.term" (click)="WIPNoSelect(w)"
                    style="padding: 0px; margin-bottom: 7px; cursor: pointer; border-top: 10px solid #F8F8F8; padding-left: 10px;">
                    <div style="display: inline-block; vertical-align: top; width: 6%;">
                        <input type="checkbox" class="chkbox-darkblue" id="wip" style="margin-left: 10px; margin-top: 10px;" name="wip"
                            value="true" [(ngModel)]="w.isSelected" (ngModelChange)="WIPNoSelect(w)">
                    </div>
                    <div style="display: inline-block; width: 94%;">
                        <div class="col-md-6 col-sm-6 col-6 font13"
                            style="display: inline-block; font-weight: bold; margin-top: 5px;">
                            {{w.JobNo}}
                        </div>

                        <div class="col-md-6 col-sm-6 col-6 font13"
                            style="display: inline-block; text-align: right; margin-top: 5px; ">
                            <span style="color: #4caf50; margin-right:5px;"><i class="fa fa-calendar"></i> </span>{{w.TargetDT | todayTommorow}}
                        </div>

                        <div class="col-md-12 col-lg-12 col-12">
                            <div *ngIf="w.CstrRelName != ''" class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" title="Customer"
                                style="display: inline-block; font-size: 12px; padding: 3px 10px; margin-right: 5px; margin-bottom: 5px;">
                                <i class="zmdi zmdi-city-alt"></i> {{w.CstrRelName}}
                            </div>
                            <div *ngIf="w.Stage != ''" class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" title="Stage"
                                style="display: inline-block; font-size: 12px; padding: 3px 10px; margin-right: 5px; margin-bottom: 5px;">
                                <i class="fa fa-bar-chart" aria-hidden="true"></i> {{w.Stage}}
                            </div>
                            <div class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" *ngFor="let i of w.Gen" title="Item"
                                style="display: inline-block; font-size: 12px; padding: 3px 10px; margin-right: 5px; margin-bottom: 5px;">
                                <i class="zmdi zmdi-widgets"></i> {{i.ItemName}}
                            </div>
                        </div>
                        <!-- <div class="col-md-6 col-sm-6 col-6" style="color: #777; font-size: 14px; display: inline-block;">
                        
                    </div>
                    <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; text-align: right; font-size: 14px; margin-top: 5px;">
                        
                    </div> -->
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!--Footer-->
    <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
        <span class="darkBlueButton left47 brdrRadius3" (click)="selectJOBDetails()"
            style="padding: 0px 10px; cursor: pointer;  position: fixed; font-size: 14px; ">
            <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Select</span>
        </span>
    </div>
</ng-template>

<button id="openModal" (click)="openModal(selection)" hidden="true"></button>

<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>
